import React from 'react'

const OrderInfoDonation = props => (
  <div className='row product-brand pt-3  px-2'>
    <div className='col-12 txt-title-3 txt-body-sm txt-font-body color-ui-2 txt-left  justify-content-center align-self-center '>
      <p className='txt-body-sm txt-subtitle txt-font-body color-ui-2'>
        Resgate realizado em:{' '}
        <strong>
          17/10/2018 às 14h13
        </strong>
      </p>
      <p className='txt-body-sm txt-subtitle txt-font-body color-ui-2'>
        Trasação:{' '}
        <strong>
          Doação de pontos
        </strong>
      </p>
      <p className='txt-body-sm txt-subtitle txt-font-body color-ui-2'>
        Valor em pontos:{' '}
        <strong>5.000,00 pts</strong>
      </p>
      <p className='txt-body-sm txt-subtitle txt-font-body color-ui-2'>
        Valor em dinheiro convertido:{' '}
        <strong>
          R$ 5.000,00
        </strong>
      </p>
    </div>
  </div>
)

export default OrderInfoDonation



// WEBPACK FOOTER //
// ./src/features/AboutOrderDonation/OrderInfoDonation.js